<fp-theme [theme]="theme$ | async" [loading]="loading$ | async" [saving]="saving$ | async"
    [savingFavicon]="savingFavicon$ | async" (update)="update($event)" (updateFavicon)="updateFavicon($event)"
    (delete)="delete($event)" (edit)="edit($event)">
</fp-theme>
